import Icon from '../components/Icon.vue'

Icon.register({
  'people-carry': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M128 96C154.5 96 176 74.5 176 48S154.5 0 128 0 80 21.5 80 48 101.5 96 128 96zM512 96C538.5 96 560 74.5 560 48S538.5 0 512 0 464 21.5 464 48 485.5 96 512 96zM637.7 468.1L593.7 358.1 552.6 404.5 550.6 422.7 578.3 491.9C583.3 504.4 595.3 512 608 512 612 512 616 511.3 619.9 509.7 636.3 503.1 644.3 484.5 637.7 468.1zM603.5 258.3L585 178.1C580.4 158.1 566.4 141.3 547.5 133.2 529 125.2 508.5 126.5 491.4 136.5 468.7 149.9 451.7 171 443.3 195.9L432 229.8 416 240V144C416 135.2 408.8 128 400 128H240C231.2 128 224 135.2 224 144V240L207.9 229.8 196.6 195.9C188.3 170.9 171.2 149.9 148.5 136.5 131.3 126.5 110.9 125.2 92.4 133.2 73.5 141.3 59.5 158.1 54.9 178.1L36.5 258.3C31.9 278.3 37.2 299.5 50.9 315L118.1 390.9 128.2 483.5C130 499.8 143.8 512 160 512 161.2 512 162.3 511.9 163.5 511.8 181.1 509.9 193.7 494.1 191.8 476.5L181.7 383.7C180.2 370.7 174.8 358.6 166.1 348.7L122.8 299.7 140.4 229.4 147.2 249.8C151.3 262.3 159.1 273.2 171.7 282.4L222.8 314.9C227.4 317.8 234.9 319.5 240 319.9H400C405.1 319.5 412.6 317.8 417.2 314.9L468.3 282.4C480.9 273.2 488.7 262.4 492.8 249.8L499.6 229.4 517.2 299.7 473.9 348.7C465.2 358.6 459.8 370.7 458.3 383.7L448.2 476.5C446.3 494.1 459 509.9 476.5 511.8 477.7 511.9 478.8 512 480 512 496.1 512 510 499.9 511.8 483.5L521.9 390.9 589.1 315C602.7 299.5 608.1 278.3 603.5 258.3zM46.3 358.1L2.3 468.1C-4.3 484.5 3.7 503.1 20.1 509.7 36.9 516.3 55.2 508 61.7 491.9L89.4 422.7 87.4 404.5 46.3 358.1z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/people-carry.js
// module id = 3EKT
// module chunks = 144